/*
 * @Description: 字符串相关的工具集
 * @Author: fiveonelei
 * @Date: 2022-01-20 14:47:46
 * @FilePath: /vise/packages/app-share/src/utils/string.ts
 */
/**
 * 将字符串中的特殊字符转换为实体
 * @param {String} str 待转换字符串
 */
export function encodeHtml(str: string) {
  return `${str}`
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\x60/g, '&#96;')
    .replace(/\x27/g, '&#39;')
    .replace(/\x22/g, '&quot;');
};

/**
 * 把图像em标签转换为img图片标签, 不可在SSR阶段调用
 * @param {String} 待处理内容
 * @returns {String} 处理后的的内容
 */
export function transferUbbToImg(content: string) {
  const imgName = window.devicePixelRatio > 1 ? '@2x' : '';
  const isIOS = /iPhone|iPad/.test(navigator.userAgent);
  const reg = new RegExp('\\[em\\]e(\\d{3,10})\\[\\/em\\]', 'g');
  return content.replace(reg, (str: string, $1) => {
    let imgType = '.gif';
    if (!isIOS && Number($1) < 200) {
      imgType = '.png';
    }
    const emojiImg = `<img class='i-emoji-m' src='//qzonestyle.gtimg.cn/qzone/em/e${$1}${imgName}${imgType}' alt='表情' >`;
    return emojiImg;
  });
}
